import { apiClient } from '../../gateways/api'
import type { FetchProjectdossierGlobalsLists } from '../types/FetchProjectdossierGlobalsLists'

export { fetchProjectdossierGlobalsLists, initialState }

const initialState: FetchProjectdossierGlobalsLists = {
  data: {
    status: [],
  },
}

const fetchProjectdossierGlobalsLists = async (): Promise<
  FetchProjectdossierGlobalsLists['data']
> => {
  const { data } = await apiClient({
    url: '/rest/projectdossier/lists/globals',
    method: 'GET',
  })
  return data
}
